import { useNavigate, Link } from "react-router-dom";
import { PageLoader } from "#/components/common/PageLoader";
import { ErrorState } from "#/components/common/ErrorState";
import { RoleForm } from "../components/RoleForm";
import { useCreateRole, usePermissionOptions } from "../hooks";
import type { RoleFormValues } from "../types";
import { ArrowLeft } from "lucide-react";

export default function RoleCreatePage() {
  const navigate = useNavigate();
  const createRole = useCreateRole();
  const permissionsQuery = usePermissionOptions();

  async function handleSubmit(values: RoleFormValues) {
    const created = await createRole.mutateAsync({
      code: values.code,
      name: values.name,
      description: values.description,
      active: values.active,
      permissionCodes: values.permissionCodes,
    });

    navigate(`/admin/roles/${created.id}`);
  }

  if (permissionsQuery.isLoading) {
    return <PageLoader label="Loading permissions..." />;
  }

  if (permissionsQuery.isError) {
    return (
      <ErrorState
        title="Failed to load permissions"
        message={
          permissionsQuery.error instanceof Error
            ? permissionsQuery.error.message
            : "Could not load permission options for role setup."
        }
      />
    );
  }

  return (
    <div className="space-y-6">
      <div>
        <button
          onClick={() => navigate(-1)}
          className="inline-flex items-center gap-2 text-sm font-semibold text-emerald-700 hover:underline"
        >
          <ArrowLeft className="h-4 w-4" />
          Go back
        </button>

        <h1 className="mt-3 text-2xl font-bold text-slate-900">Create role</h1>
      </div>

      <RoleForm
        permissions={permissionsQuery.data ?? []}
        isSubmitting={createRole.isPending}
        onSubmit={handleSubmit}
      />
    </div>
  );
}
